import React from "react"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
import Stack from "@mui/material/Stack"
import { ITEM, MAKE_WISH_TRUE, OWNER } from "constants/index"
import { useAppSelector } from "appRedux/hooks"
import { updateShowGeniesList, updateShowSelectGeniesBottomSheet } from "appRedux/slices/wishListSlice"
import BottomSheet from "components/atoms/BottomSheet"
import CTA from "components/atoms/CTA"
import UserCard from "components/molecules/UserCard"
import withRoleBasedPermission from "components/HOCs/withRoleBasedPermission"

type GeniesListProps = {
  show: boolean;
  genies: UserDto[];
  onOpen: () => void;
  onClose: () => void;
}

const CTAWithRoleBasedPermission = withRoleBasedPermission(Stack)

export default function GeniesList(props: GeniesListProps) {
  const { show, genies, onOpen, onClose } = props

  const userProfile = useAppSelector((state) => state.user.profile)
  const role = useAppSelector((state) => state.global.role)

  const { t } = useTranslation()
  const dispatch = useDispatch()

  function handleEditGeniesButtonClicked() {
    dispatch(updateShowGeniesList(false))
    dispatch(updateShowSelectGeniesBottomSheet(true))
  }

  return (
    <BottomSheet
      id="select-genies"
      title={role === OWNER ? t("items.selectGenies") : t("items.selectGenies")}
      show={show}
      height={"60vh"}
      openBottomSheet={onOpen}
      closeBottomSheet={onClose}
    >
      <Stack gap="8px" overflow="scroll" height="calc(100% - 100px)">
        {genies?.map(user => (
          <UserCard
            key={user?.id}
            id={user?.id}
            handle={user?.handle}
            name={user?.name}
            avatar={user?.avatar}
            avatarWidth={"46px"}
            label={userProfile?.id === user?.id ? t("general.myself") : undefined}
          />
        ))}
      </Stack>

      <CTAWithRoleBasedPermission
        resource={ITEM}
        action={MAKE_WISH_TRUE}
      >
        <CTA
          variant="contained"
          onClick={handleEditGeniesButtonClicked}
        >
          {t("general.edit")}
        </CTA>
      </CTAWithRoleBasedPermission>
    </BottomSheet>
  )
}
